import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { sprLog } from "./spr";
import RecordIMG from "Assets/images/record.gif";
import { langCheck } from "Pub/js/utils";
import platform from "Pub/js/platform";
import { setStore, getStore } from "Pub/js/storageUtils";
import { globalHotKeys } from "Pub/js/globalHotKeys";
const { NCTooltip, NCHotKeys } = platform.base;
import { changeDrawer, changeIsAccountSettingSpr } from "Store/appStore/action";

class RecordSPR extends Component {
    constructor(props) {
        super(props);
        this.state = { hoverType: false };
    }
    /**
     * spr录制
     */
    handleSprClick = () => {
        let { changeIsAccountSettingSpr, userId } = this.props;
        let showSpr = getStore("SHOWSPR");
        setStore('SHOWSPR', !showSpr);
        changeIsAccountSettingSpr(false);
        this.setState({ update: true });
        sprLog.call(this, showSpr, userId);
    };
    /**
     * spr悬停
     */
    handleSprOver = () => {
        this.setState({ hoverType: true });
    };
    handleSprOut = () => {
        this.setState({ hoverType: false });
    };
    handleVisibilityChange = () => {
        this.setState({ update: true });
    };
    componentDidMount() {
        // 更新页面为了拿到local的showspr
        this.setState({ update: true });
        this.modifySPR = document.createEvent('Event');
        this.modifySPR.initEvent("modifySPR", false, true);
        this.modifySPR.key = "status";
        document.addEventListener(
            "visibilitychange",
            this.handleVisibilityChange,
        );
        //绑定spr快捷键
        globalHotKeys.bind(hotkeys => hotkeys.SPR, this.handleHotKey);
    }
    componentWillReceiveProps(nextProps) {
        let { isAccountSettingSpr } = nextProps;
        if (isAccountSettingSpr) {
            this.handleSprClick();
        }
    }
    componentWillUnmount() {
        document.removeEventListener(
            "visibilitychange",
            this.handleVisibilityChange,
        );
        //移除spr快捷键
        globalHotKeys.remove(hotkeys => hotkeys.SPR, this.handleHotKey);
    }

    handleHotKey = () => {
        // 工作台管理进来的首页 屏蔽spr快捷键
        // 这块儿不知道为啥要屏蔽，先放开吧
        // if(window.isDesign) {return;}
        this.handleSprClick();
        changeDrawer(false);
    }
    render() {
        let { hoverType } = this.state;
        const { changeDrawer } = this.props;
        let showSpr = true; //录制 spr 默认true 解决首次登录SHOWRPR无缓存
        if (getStore('SHOWSPR') == null) {
            setStore('SHOWSPR', true); 
        } else {
            showSpr = getStore('SHOWSPR');
        }

        return (
            <div
                style={showSpr ? { display: 'none' } : { display: 'block' }}
                className="spr-record"
                onClick={
                    () => {
                        this.handleSprClick();
                    }
                }
                onMouseEnter={this.handleSprOver}
                onMouseLeave={this.handleSprOut}
            >
                {/* <NCHotKeys
                    keyMap={{
                        addActionSign: ["NC_ADD", "ctrl+`"],
                    }}
                    handlers={{
                        addActionSign: () => {
                            this.handleSprClick();
                            changeDrawer(false);
                        },
                    }}
                    focused={true}
                /> */}
                <NCTooltip
                    placement="bottom"
                    trigger="hover"
                    delayShow={500}
                    delay={1}
                    mouseLeaveDelay={0}
                    overlay={showSpr
                        ? langCheck(
                            "0000PUB-000121",
                        ) /* 国际化处理： 开始录制SPR*/
                        : langCheck(
                            "0000PUB-000122",
                        ) /* 国际化处理： 结束录制SPR*/}
                >
                    {showSpr ? (
                        <div className="iconContainer-spr">
                            <i className="iconfont icon-luzhi1" />
                        </div>
                    ) : hoverType ? (
                        <div className="iconContainer-spr">
                            <i className="iconfont icon-zanting" />
                        </div>
                    ) : (
                        <div className="iconContainer-spr">
                            <img src={RecordIMG} width="20px" />
                        </div>
                    )}
                </NCTooltip>
            </div>
        );
    }
}
RecordSPR.propTypes = {
    userId: PropTypes.string.isRequired,
    isAccountSettingSpr: PropTypes.string.isRequired,
    recordSpr: PropTypes.string.recordSpr,
    changeDrawer: PropTypes.func.isRequired,
    changeIsAccountSettingSpr: PropTypes.func.isRequired,
};
export default connect(
    state => ({
        userId: state.appData.userId,
        recordSpr: state.appData.recordSpr,
        isAccountSettingSpr: state.appData.isAccountSettingSpr,
    }),
    {
        changeDrawer,
        changeIsAccountSettingSpr,
    },
)(RecordSPR);
